<template>
	<div class="align-center">

		<template v-if="ready">
			<Heading
				:title="translations.labels.acceptInvitation"
			/>
			<div
				v-if="!tokenValid"
				class="margin-top-30"
			>
				<el-alert
					:title="translations.messages.invalidToken"
					:closable="false"
					type="error"
					center
				/>
				<div class="align-center margin-top-20">
					<router-link to="/login">
						<small>{{ translations.labels.backToLogin }}</small>
					</router-link>
				</div>
			</div>
			<div
				v-if="error"
				class="margin-top-30"
			>
				<el-alert
					:title="error"
					:closable="false"
					type="error"
					center
				/>
			</div>
			<div
				v-if="showMessage"
				class="margin-top-30"
			>
				{{ translations.messages.successConfirmMember }}
				<div class="align-center margin-top-20">
					<router-link to="/login">
						<small>{{ translations.labels.backToLogin }}</small>
					</router-link>
				</div>
			</div>
		</template>

		<template v-else>
			<Heading
				:title="translations.labels.acceptInvitation"
				:subtitle="translations.labels.verifyingToken"
			/>
			<div
				v-loading="true"
				class="margin-top-30"
				style="height: 50px"
			/>
		</template>

	</div>
</template>

<script>
import {
	_verifyInvitation,
	_acceptInvitation,
	_getTeams
} from '@/services/api/teams'

import logoutUser from '@/services/mixins/logoutUser'

export default {
	name: 'Invitation',
	metaInfo () {
		return {
			title: this.translations.labels.acceptInvitation
		}
	},
	mixins: [
		logoutUser
	],
	components: {
		Heading: () => import( /* webpackPrefetch: true */ '@/views/Public/Components/Heading')
	},
	data () {
		return {
			error: null,
			showMessage: false,
			tokenValid: false,
			tempUser: null
		}
	},
	created () {
		this.ajaxVerifyToken()
	},
	methods: {
		ajaxVerifyToken () {
			const data = {
				token: this.$route.params.token
			}
			_verifyInvitation (data)
				.then(response => {

					this.tokenValid = true
					this.tempUser = response

					if (!this.tempUser.accountId) {

						if (this.objectLength(this.auth)) {
							this.logoutUser(false)
						}

						setTimeout (() => {
							this.redirectTo(`/register/${this.$route.params.token}`)
						}, 1000)

					} else {

						if (this.objectLength(this.auth) && (this.user.id !== this.tempUser.accountId)) {
							this.logoutUser(false)
						}

						this.ajaxAcceptInvitation()

					}

				})
				.catch(() => {
					setTimeout(() => this.$store.dispatch('setReady', true), 1000)
				})
		},
		ajaxAcceptInvitation () {
			const data = {
				token: this.$route.params.token
			}
			_acceptInvitation (data)
				.then(() => {
					if (this.user.id === this.tempUser.accountId) {
						this.ajaxLoadTeams()
					} else {
						this.$store.dispatch('setReady', true)
						this.showMessage = true
					}
				})
				.catch(error => {
					const errorCode = error.response.data.status
					this.$store.dispatch('setReady', true)
					this.error = this.translations.statusCodes[errorCode] ? this.translations.statusCodes[errorCode] : this.translations.statusCodes['default']
				})
		},
		ajaxLoadTeams () {
			_getTeams ()
				.then(response => {
					this.$store.dispatch('setTeams', response)
					this.redirectTo(`/${process.env.VUE_APP_DEFAULT_PAGE}`)
					this.displayMessage(this.translations.messages.successInvitation, 'success')
				})
		}
	}
}
</script>
